import { useQuery } from "@tanstack/react-query";

import { AnalyticsStatsCardWithSeparator } from "components/analytics/display-card-with-separator";
import { AnalyticsStatsCardPlaceholderWithSeparator } from "components/analytics/placeholder-with-separator";
import { projectKeys } from "components/project/queries";
import { fetchActiveProjectsCount } from "components/timesheet/dashboard/projects-coordinating/api";

export function ActiveProjectsCard() {
  const { data, isLoading } = useQuery({
    queryKey: projectKeys.activeCount(),
    queryFn: fetchActiveProjectsCount,
  });

  if (isLoading) return <AnalyticsStatsCardPlaceholderWithSeparator />;
  return <AnalyticsStatsCardWithSeparator label="Active" value={data} />;
}
